import {
  UpdateProjectSettingsRequest as TcpsUpdateProjectSettingsRequest,
  UpdateProjectSettingsRequest,
} from '../../generated/index';
import {
  mapToTcpsModel as mapToTcpsUnit,
  mapToDomain as mapToDomainUnit,
} from './unit-settings-mapper';
import {
  mapToTcpsModel as mapToTcpsSync,
  mapToDomain as mapToDomainSync,
} from './sync-settings-mapper';
import {
  mapToTcpsModel as mapToTcpsNotification,
  mapToDomain as mapToDomainNotification,
} from './notification-settings-mapper';
import { ProjectSettings } from '@trimble/types';

export const mapToTcpsModel = (
  input: ProjectSettings
): UpdateProjectSettingsRequest => ({
  unitSettings: input.unitSettings
    ? mapToTcpsUnit(input.unitSettings)
    : undefined,
  syncSettings: input.syncSettings
    ? mapToTcpsSync(input.syncSettings)
    : undefined,
  notificationSettings: input.notificationSettings
    ? (mapToTcpsNotification(input.notificationSettings) ?? undefined)
    : undefined,
  isTodosRestricted: input.isTodosRestricted,
  isProjectInviteRestricted: input.isProjectInviteRestricted,
});

export const mapToDomain = (
  input: TcpsUpdateProjectSettingsRequest
): ProjectSettings => ({
  unitSettings: input.unitSettings
    ? mapToDomainUnit(input.unitSettings)
    : undefined,
  syncSettings: input.syncSettings
    ? mapToDomainSync(input.syncSettings)
    : undefined,
  notificationSettings: input.notificationSettings
    ? mapToDomainNotification(input.notificationSettings)
    : undefined,
  isTodosRestricted: input.isTodosRestricted,
  isProjectInviteRestricted: input.isProjectInviteRestricted,
});
